module.exports = __webpack_public_path__ + "static/img/08.fe73527.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/08.png
// module id = mAq9
// module chunks = 1